<template>
  <div
    v-if="builderPreview"
    class="fixed end-4 bottom-4 z-40"
  >
    <div class="flex size-12 items-center justify-center rounded-full bg-primary text-white shadow-lg">
      <UIcon
        name="i-lucide-message-circle"
        class="size-5"
      />
    </div>
  </div>
  <div
    v-else-if="enabled"
    class="fixed end-4 bottom-4 z-40"
  >
    <button
      v-if="!open"
      type="button"
      class="flex size-12 items-center justify-center rounded-full bg-primary text-white shadow-lg"
      @click="open = true"
    >
      <UIcon
        name="i-lucide-message-circle"
        class="size-5"
      />
    </button>
    <div
      v-else
      class="w-[min(22rem,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-[var(--ui-border)] bg-[var(--arad-surface)] shadow-xl"
    >
      <div class="flex items-center justify-between border-b border-[var(--ui-border)] px-3 py-2">
        <p class="text-sm font-semibold">
          {{ title || greeting || 'سوال بپرسید' }}
        </p>
        <UButton
          icon="i-lucide-x"
          size="xs"
          color="neutral"
          variant="ghost"
          @click="() => { open = false }"
        />
      </div>
      <div class="max-h-72 space-y-2 overflow-y-auto p-3">
        <p
          v-if="greeting && !messages.length"
          class="text-sm text-muted"
        >
          {{ greeting }}
        </p>
        <div
          v-for="message in messages"
          :key="message.id"
          class="max-w-[90%] rounded-xl px-3 py-2 text-sm"
          :class="message.sender === 'visitor' ? 'ms-auto bg-primary text-white' : 'bg-[var(--ui-bg-muted)]'"
        >
          {{ message.body }}
        </div>
      </div>
      <form
        class="space-y-2 border-t border-[var(--ui-border)] p-3"
        @submit.prevent="send"
      >
        <AuthPhoneInput
          v-if="!threadId"
          v-model="phone"
        />
        <UInput
          v-model="draft"
          placeholder="پیام شما"
        />
        <UButton
          type="submit"
          block
          :loading="saving"
          :disabled="!canSend"
        >
          ارسال
        </UButton>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  builderPreview?: boolean
}>()

const open = ref(false)
const enabled = ref(false)
const greeting = ref('')
const phone = ref('')
const draft = ref('')
const threadId = ref('')
const saving = ref(false)
const messages = ref<Array<{ id: string; sender: string; body: string }>>([])

if (import.meta.client && !props.builderPreview) {
  $fetch<{ item: { chatEnabled: boolean; chatGreeting: string } }>('/api/leads/settings')
    .then((res) => {
      enabled.value = res.item.chatEnabled
      greeting.value = res.item.chatGreeting
    })
    .catch(() => {})
}

const canSend = computed(() => draft.value.trim() && (threadId.value || isCompleteIrMobile(phone.value)))

async function send() {
  if (!canSend.value) return
  saving.value = true
  try {
    if (!threadId.value) {
      const res = await $fetch<{ item: { threadId: string; message: { id: string; sender: string; body: string } } }>('/api/leads/chat', {
        method: 'POST',
        body: { phone: phone.value, body: draft.value.trim() },
      })
      threadId.value = res.item.threadId
      messages.value = [res.item.message]
    }
    else {
      const res = await $fetch<{ item: { id: string; sender: string; body: string } }>(`/api/leads/chat/${threadId.value}`, {
        method: 'POST',
        body: { body: draft.value.trim() },
      })
      messages.value = [...messages.value, res.item]
    }
    draft.value = ''
  }
  catch (err) {
    useToast().add({ title: apiErrorMessage(err, 'ارسال ناموفق بود'), color: 'error' })
  }
  finally {
    saving.value = false
  }
}
</script>
